import { createContext } from 'react'

export interface GuidedIFCContextValue {
  /** Advance to the next guided step (no-op on the last step). */
  goToNext: () => void
}

/**
 * Exposes guided-wizard navigation to the current step's content, so a step can advance itself
 * (e.g. auto-proceeding once an upload has finished). Null outside the guided drawer.
 */
export const GuidedIFCContext = createContext<GuidedIFCContextValue | null>(null)
